export default __webpack_public_path__ + "static/B0174-305733167610b40256fddf6e0e30bea0.png";